import styled from "styled-components";
import { Pagination } from "@mui/material";

export const StyledPagination = styled(Pagination)`
  &.MuiPagination-root {
    width: 100%;
    justify-content: flex-end;
    display: flex;
    padding: 10px 115px;
  }
  & button {
    &.Mui-selected {
      //color: #006f35;
      color: ${({ theme }) => {
        return theme.colors.green;
      }};
      //border-color: #006f35;
      border-color: ${({ theme }) => {
        return theme.colors.green;
      }};
    }
  }
`;
